<template>
   <div>
      <v-container>
         <v-row>
            <v-col cols="12" md="12">
               <v-toolbar dense color="primary white--text" bottom>
                  <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                     Manage Roles
                  </v-toolbar-title>
                  <v-icon color="white" v-else>mdi-account-settings-outline</v-icon>
               </v-toolbar>
               <v-toolbar>
                  <v-btn class="ma-2" small outlined color="indigo" @click="createRole">
                     <v-icon left>mdi-plus</v-icon>
                     <div v-if="$vuetify.breakpoint.mdAndUp">Create</div>
                  </v-btn>
               </v-toolbar>
            </v-col>
         </v-row>
         <v-row no-gutters>
            <v-col md="12">
               <v-card class="overflow-y-auto">
                  <v-card-title>
                     <v-text-field
                        v-model="table_search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                     ></v-text-field>
                  </v-card-title>
                  <v-data-table
                     dense
                     :headers="table_headers"
                     :items="roledata"
                     item-key="role_id"
                     single-select
                     :search="table_search"
                     @click:row="roleRowClick"
                  >
                     <!-- eslint-disable-next-line -->
                     <template v-slot:item.actions="{item}">
                        <v-icon small class="mr-2" @click="editRole(item)">
                           mdi-pencil
                        </v-icon>
                        <v-icon small @click="deleteRole(item)">
                           mdi-delete
                        </v-icon>
                     </template>
                  </v-data-table>
               </v-card>
            </v-col>
         </v-row>
      </v-container>
      <confirm-dialog ref="confirm"></confirm-dialog>
   </div>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg";

   export default {
      inject: ["ShowMessage"],

      components: {
         "confirm-dialog": ConfirmDlg,
      },

      data() {
         return {
            roledata: [],
            table_headers: [
               {
                  text: "Role Name",
                  value: "role_name",
                  width: "25%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Description",
                  value: "role_description",
                  width: "25%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Status",
                  value: "role_statustext",
                  width: "10%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "",
                  value: "actions",
                  width: "10%",
                  sortable: false,
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
            table_search: "",
         };
      },
      methods: {
         roleRowClick(item, row) {
            row.select(!row.isSelected);
         },

         async getRoleList() {
            await this.$http({
               url: "/common/getrolelist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
                  allrole: 1,
               },
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.roledata = response.data.rolelist;
               } else {
                  this.roledata = [];
               }
            });
         },

         createRole() {
            this.$router.push({name: "AddRole"});
         },

         editRole(item) {
            this.$router.push({
               name: "EditRole",
               params: {role_id: item.role_id},
            });
         },

         async deleteRole(item) {
            await this.$http({
               url: "/common/checkroleassignment.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  role_id: item.role_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     let roleassignedcount = response.data.roleassignedcount;
                     if (roleassignedcount > 0) {
                        this.ShowMessage({
                           title: "Error",
                           message:
                              "Role cannot be deletd. " +
                              `${item.role_name} role assigned to ${roleassignedcount} users`,
                           color: "red",
                        });
                     } else {
                        this.$refs.confirm
                           .open(
                              "Warning",
                              "Are you sure you want to delete " + item.role_name + "?",
                              {color: "orange"}
                           )
                           .then((reply) => {
                              if (reply) {
                                 this.doDeleteRole(item);
                              }
                           });
                     }
                  }
               }
            });
         },

         async doDeleteRole(item) {
            await this.$http({
               url: "/common/removerole.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  role_id: item.role_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     let index = this.roledata.findIndex((x) => x.role_id == item.role_id);
                     if (index !== -1) {
                        this.roledata.splice(index, 1);
                     }
                  }
               }
            });
         },
      },
      mounted() {
         this.getRoleList();
      },
   };
</script>
